var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,1.2L1.1,4.3l-1-1.2L3.7,0L4.7,1.2z M2.9,3.8C4.3,2.4,6,1.7,8,1.7s3.7,0.7,5.1,2.1s2.1,3.1,2.1,5.1s-0.7,3.6-2.1,5.1 S10,16,8,16s-3.7-0.7-5.1-2.1s-2.1-3.1-2.1-5.1S1.5,5.2,2.9,3.8z M4.1,12.8c1.1,1.1,2.4,1.6,3.9,1.6s2.9-0.5,3.9-1.6s1.6-2.4,1.6-4 S13,6,11.9,4.9S9.5,3.3,8,3.3S5.1,3.8,4.1,4.9S2.4,7.3,2.4,8.8S3,11.7,4.1,12.8z M8.4,4.9v4.2l3.2,1.9l-0.6,1L7.2,9.7V4.9H8.4z  M15.9,3.1l-1,1.2l-3.7-3.1l1-1.2L15.9,3.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.a6f09e92631b18f975f4ac8da90399b5.svg";
export { ForwardRef as ReactComponent };